import * as React from 'react';

import { StudioAppConfig } from 'glance-datatypes';
import Utils from '../../Utils';
import { connect } from 'react-redux';

// Needed for onTouchTap
// http://stackoverflow.com/a/34015469/988941

interface GlanceDraftRedirectProps {
    history?: any;
    params: any;
    studioAppConfig: StudioAppConfig;
}

class GlanceDraftRedirect extends React.Component<GlanceDraftRedirectProps, {}> {
    constructor(props: GlanceDraftRedirectProps) {
        super(props);
    }

    componentDidMount() {
        let appConf = this.props.studioAppConfig;
        if (appConf && appConf.currentToken) {
            this.props.history.push('/' + Utils.getReadableRoleName(appConf.currentToken.role) + '/drafts/draftIds/' + this.props.params.draftIds);
        } else {
            this.props.history.push('/');
        }
    }

    render() {
        return (
            <div></div>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        studioAppConfig: state.studioAppConfig,
    };
};

export default connect(mapStateToProps)(GlanceDraftRedirect);




// WEBPACK FOOTER //
// ./src/pages/drafts/GlanceDraftRedirect.tsx